import { Modal } from 'antd'
import { files, infoMsg } from '@services/api'
import { fileExt } from '@texts/files'
import download from '@utils/download'

export const titles = {
    title: 'הגשת בקשה כללית',
    identity: 'ת"ז',
    phone: 'נייד',
    id: 'מזהה',
    searchTitle: 'חיפוש לפי:',
    searchBtn: 'חיפוש',
    chooseOption: 'נושא הבקשה',
    chooseUser: 'בקשה עבור',
    description: 'פירוט הבקשה',
    sendBtnTitle: 'שליחה',
    settingsTitle: 'בקשה כללית',
    settingsFlyTitle: 'Mediwho Fly',
    userNotFound: 'לקוח לא קיים או אין לו מנוי',
    familyMember: 'הלקוח הנבחר רשום כבן משפחה',
    sendSuccess: "הבקשה הוגשה בהצלחה, מס' בקשה -",
    fatalError: 'אירעה שגיאה',
    uploadTitle: 'הוספת קובץ',
    goWithThisUser: 'האם רוצה להמשיך עם',
    yes: 'לבקשה נוספת',
    no: 'לבקשה חדשה',
    confirm: 'אישור',
    formatError: 'נא להעלות קבצים בפורמט המתאים',
    validList: 'pdf, jpeg, docx, doc, png, jpg, txt, csv, xls, xlsx',
    fileTooBig: 'הקובץ גדול מדי, נא לבחור קובץ עד 10 MB',
    tryAddFileTwice: 'הקובץ כבר נוסף',
    crmErrorTitle: 'הלקוח לא רשום בCRM',
    countFile: 'לא ניתן להוסיף יותר מ-20 קבצים',
    checkboxTitle: 'הגשת בקשה ידנית',
    subOption_t: 'בחירת חברת ביטוח',
    noGrProduct: 'מינוי לא מתאים',
    subAreaTitle: 'בחרו את סוג הבקשה',
    reportTitle: 'תאריך קרות המקרה בחו״ל',
    reportNotExist: 'לא נרכש מינוי לתאריך זה',
    reportToLate: 'לא ניתן לדווח, מאחר וחלפו יותר מ-7 ימים מיום החזרה',
    reportToEarly: 'לא ניתן לבצע דיווח לתאריך עתידי',
    descriptionReport: 'פירוט המקרה',
    reportSuccess: 'דיווח הוגש בהצלחה',
    oneMoreReport: 'לדיווח נוסף',
    continueFReq: 'להגשת בקשה',
    reportInfoMessage: 'טרם בוצע דיווח, יש לדווח על קרות המקרה לפני הגשת הבקשה',
    existReport: `קיים דיווח ללקוח הזה`,
    needDocument: '*יש להוסיף הפניה'
}
export const subOptionsList = [
    { id: 1, title: 'הראל' },
    { id: 2, title: 'מגדל' },
    { id: 3, title: 'כלל' },
    { id: 4, title: 'הפניקס' },
    { id: 5, title: 'מנורה מבטחים' },
    { id: 6, title: 'אלטשולר שחם' },
    { id: 7, title: 'איילון' },
    { id: 8, title: 'הכשרה' },
    { id: 9, title: 'שלמה ביטוח' },
    { id: 10, title: 'פסגות' },
    { id: 11, title: 'מיטב דש' },
    { id: 12, title: 'הלמן אלדובי' },
    { id: 13, title: 'פספורטכארד' },
    { id: 14, title: 'ביטוח ישיר' },
    { id: 15, title: 'AIG' },
    { id: 15, title: 'MediWho' }
]
// prettier-ignore
export const subAreaTitles = [{ title: 'בקשה כללית', id: 1 }, { title: 'Mediwho Fly', id: 2 }]
export const searchTypes = [
    { id: 1, title: titles.phone },
    { id: 2, title: titles.identity },
    { id: 3, title: titles.id }
]

// ***** download files utils ***** \\
export const tryAddTwice = param => {
    param.setState({ loading: false })
    Modal.error({ title: titles.tryAddFileTwice, okText: titles.confirm })
}
export const errorFile = (title, content, param) => {
    param.setState({ loading: false })
    Modal.error({ title, content, okText: titles.confirm })
}
export const countFile = param => {
    param.setState({ loading: false })
    Modal.error({ title: titles.countFile, okText: titles.confirm })
}
export const fileValidator = ({ name, size }, accept = false, allowedSize = 10635049) => {
    const extensions = accept || ['pdf', 'docx', 'doc', 'png', 'jpg', 'txt', 'csv', 'xls', 'xlsx', 'jpeg']
    const fileExtension = name.substr(name.lastIndexOf('.') + 1)
    const filterExt = extensions.filter(ext => ext.toLowerCase() === fileExtension.toLowerCase())

    if (size >= allowedSize) return 'FILETOOBIG'
    if (!filterExt.length) return 'UNSUPPORTED'
    return true
}
export const downloadFile = async file => {
    const downloadedFile = await files
        .assert(file.viewUrl)
        .then(res => new Blob([res.data], { type: fileExt[file.viewExt] }))
    download(downloadedFile)
}

export const deleteFile = async (e, param) => {
    const { fileArrayView, fileArraySend } = param.state
    param.setState({ loading: true })
    try {
        await files.delete(e).then(res => {
            if (res.status === 200) {
                param.setState({ loading: false })
                param.setState({ fileArrayView: [...fileArrayView.filter(file => file.uid !== e.uid)] })
                param.setState({ fileArraySend: [...fileArraySend.filter(file => file.id !== e.uid)] })
            } else {
                param.setState({ loading: false })
                errorFatalModal()
            }
        })
    } catch (e) {
        param.setState({ loading: false })
        errorFatalModal()
    }
}
export const checkIfFileExist = (files, fileId) => fileId.filter(file => file.validity_ === files.name).length
// ***** download files utils ***** \\

// ***** modals section ***** \\
export const sendEmail = async res => await infoMsg.sendMailCRMError(res)

export const crmModal = (param, res) => {
    sendEmail(res)
    param.setState({ loading: false })
    Modal.error({ title: titles.crmErrorTitle, okText: titles.confirm })
    resetFields(param, false)
}

export const errorFatalModal = () => Modal.error({ title: titles.fatalError, okText: titles.confirm })

export const errorModal = (param, title) => {
    Modal.error({ title, okText: titles.confirm })
    if (param) resetFields(param, false)
}
export const successModal = (id, nameInput, param) => {
    param.setState({ loading: false })
    Modal.confirm({
        title: `${titles.sendSuccess} ${id}`,
        okType: 'primary',
        okText: titles.yes,
        cancelText: titles.no,
        onOk() {
            continueWork(param)
        },
        onCancel() {
            resetFields(param, false)
        }
    })
}

export const successReportModal = (param, title, submitted) => {
    param.setState({ loading: false })
    Modal.confirm({
        title,
        okType: 'primary',
        okText: titles.continueFReq,
        cancelText: titles.oneMoreReport,
        onOk() {
            param.setState({ textArea: '' })
            param.setState({ reportSubmitted: true })
        },
        onCancel() {
            param.setState({ textArea: '' })
            if (submitted) param.setState({ reportDateSet: '' })
        }
    })
}
export const warningModal = () => Modal.warning({ content: titles.familyMember, okText: titles.confirm })
export const warningReportModal = () => Modal.warning({ content: titles.reportInfoMessage, okText: titles.confirm })
// ***** modals section ***** \\

export const textAreaValueJson = ({ target }, param) => {
    const { filesArray, userName, description, message, userId, provideId, service_content } = JSON.parse(target.value)
    // prettier-ignore
    const fileObjView = filesArray.map(({ id, fName, url, extension }) => ({ uid: id, name: fName, url: '', viewUrl: url, viewExt: extension }))

    param.setState({ nameInput: userName })
    param.setState({ optionTitle: description })
    param.setState({ textArea: message })
    param.setState({ userId: userId })
    param.setState({ providerId: provideId })
    param.setState({ fileArrayView: [...fileObjView] })
    param.setState({ objectInto: service_content })
    param.setState({ jsonInput: target.value })
    param.setState({ showDataInputs: true })

    // prettier-ignore
    if (service_content.subOption) param.setState({ subOptionTitle: service_content.subOption.title, isSubOption: true })
}

export const resetFields = (param, config) => {
    param.setState({
        loading: false,
        optionList: null,
        usersList: [],
        checkInput: '',
        textArea: '',
        requestBy: 1,
        nameInput: titles.chooseUser,
        optionTitle: titles.chooseOption,
        typeSearchTitle: titles.phone,
        subAreaTitle: titles.subAreaTitle,
        userId: '',
        providerId: '',
        optionId: '',
        fileArrayView: [],
        fileArraySend: [],
        objectInto: null,
        checkBox: false,
        jsonInput: '',
        isSubOption: false,
        subOptionTitle: [],
        isHasBothSubs: false,
        showDataInputs: false,
        serviceId: null,
        reportDateSet: '',
        reportSubmitted: false,
        flyMode: false
    })

    if (!config) param.setState({ typeSearchTitle: titles.phone, checkInput: '' })
}

export const continueWork = param => {
    const { optionId } = param.state
    const isNotAssistant = optionId !== 21
    param.setState({
        loading: false,
        textArea: '',
        requestBy: 1,
        fileArrayView: [],
        fileArraySend: [],
        objectInto: null,
        checkBox: false,
        jsonInput: '',
        isSubOption: false,
        subOptionTitle: []
        // subAreaTitle: titles.
        // optionTitle: titles.chooseOption,
        // optionId: '',
    })

    if (isNotAssistant) param.setState({ optionTitle: titles.chooseOption, optionId: '' })
}

export const textAreaValue = (value, param) => param.setState({ textArea: value })
// prettier-ignore
export const typeSearch = ({ id, title }, param) => param.setState({ requestBy: id, typeSearchTitle: title, checkInput: '' })

export const inputSearchValidate = (value, param) => {
    const till = param.state.typeSearchTitle === titles.identity ? 9 : 10
    return param.setState({ checkInput: value.replace(/[^0-9\.]/g, '').substring(0, till) })
}

export const setOptionName = ({ id, option_name }, param) => {
    param.setState({ isSubOption: id === 18, optionTitle: option_name, optionId: id })
    if (id !== 18) param.setState({ subOptionTitle: [] })
}

export const setSubArea = ({ title, id: type }, param) => {
    const fly = type === 2
    const regular = type === 1
    param.setState({ subAreaTitle: title, showDataInputs: true, isHasBothSubs: false })

    if (regular) {
        const { regularSub } = param.state.bothSubsData
        param.setState({
            usersList: [...regularSub],
            nameInput: regularSub[0].first_name,
            userId: regularSub[0].id,
            serviceId: 13,
            providerId: regularSub[0].parent_provider_id ? regularSub[0].parent_provider_id : regularSub[0].id
        })
    }

    if (fly) {
        const { flySub } = param.state.bothSubsData
        const { options, first_name } = flySub[0]

        param.state.setOptions(13, false, param, options, false)
        param.setState({ serviceId: 25 })
        param.setState({ flyMode: true })
        param.setState({ usersList: [...jsonParser(flySub)] })
        param.setState({ nameInput: first_name })
    }
}

export const setUserId = (item, param) => {
    if (!item.crmCheck) return crmModal(param, { data: item })
    param.setState({ nameInput: item.first_name, userId: item.id })

    if (param.state.flyMode) {
        param.setState({ textArea: '' })
        param.setState({ optionTitle: titles.chooseOption })
        param.setState({ optionId: '' })
    }
}

export const enterClick = ({ key, target }, param) => key === 'Enter' && target.value.length > 3 && param.findUsers()

export const servicePayload = params => {
    const { optionId, optionTitle, textArea, fileArraySend, serviceId } = params.state
    return {
        service: {
            id: serviceId === 25 ? serviceId : optionId,
            sku: null,
            name: optionTitle,
            price: 0,
            active: 1,
            description: optionTitle,
            iteration_type: null,
            required_token: 0,
            required_fields: null,
            service_option_id: optionId
        },
        files: fileArraySend,
        message: textArea,
        path: [],
        data: [
            {
                title: serviceId === 25 ? titles.settingsFlyTitle : titles.settingsTitle,
                value: optionTitle,
                visible: true
            }
        ]
    }
}

export const archivePayload = params => [{ date: new Date(), status: 'OPENED', message: params.state.textArea }]

export const getFlyMaxExpiration = async (subscriptions, params) => {
    await subscriptions
        .getFlyMaxExpiration()
        .then(({ data }) => data)
        .then(({ flyExpiration }) => params.setState({ flyExpiration }))
        .catch(error => console.log('getFlyMaxExpiration, general request', error))
}

export const jsonParser = arr =>
    arr.map(item => {
        const { dates_range, reports } = item
        item.dates_range = JSON.parse(dates_range)
        item.reports = reports ? JSON.parse(reports) : null
        return item
    })
